export interface TargetPaceInput {
  totalGoals: number;
  target: number;
  gameweeks: { number: number; completedAt: string | null }[];
  startGwNumber: number;
}

/**
 * How far a TARGET member is ahead of or behind the pace needed to hit their target,
 * pro-rated by how much of the league's own scoring window has been played.
 *
 * Both the completed count and the total count are scoped to gameweeks at or after the
 * league's own `startGwNumber` — a league starting mid-season must judge pace against its
 * own window, not every gameweek in the competition, most of which happened before the
 * league (or this member) even existed. Returns null before any gameweek in that window
 * has completed — nothing to compare pace against yet.
 */
export function computeTargetPace({ totalGoals, target, gameweeks, startGwNumber }: TargetPaceInput): number | null {
  const windowGws = gameweeks.filter((gw) => gw.number >= startGwNumber);
  const completedCount = windowGws.filter((gw) => gw.completedAt !== null).length;
  const totalCount = windowGws.length;
  if (completedCount === 0 || totalCount === 0) return null;
  return totalGoals - (target * completedCount / totalCount);
}
